import { http, baseURL } from '@/api/httpAxios'
import { AxiosPromise } from 'axios'
import { User } from 'interfaces/user'
import {
  authBase,
  authDevBase,
  etuIdAuthBase,
  isProduction,
} from '@/config/urls'

export default class UserAPI {
  public static getCurrentUser(
    reload = false
  ): AxiosPromise<{ user: User | null }> {
    const params = new URLSearchParams()
    if (reload) {
      params.append('reload', 'true')
    }
    return http.get('/auth/current-user', { params })
  }

  public static login(roles: string[], redirect?: string) {
    let redirectLink = ''

    if (isProduction) {
      redirectLink = `${authBase}${
        redirect ? `?redirect=${encodeURIComponent(redirect)}` : ''
      }`
    } else {
      // Dev
      redirectLink = `${authDevBase}?userId=2`
    }

    window.location.href = redirectLink
  }

  public static loginEtuId(roles: string[], redirect?: string) {
    const redirectLink = `${etuIdAuthBase}${
      redirect ? `?redirect=${encodeURIComponent(redirect)}` : ''
    }`

    window.location.href = redirectLink
  }

  public static changeUser(userId: number) {
    window.location.href = `${baseURL}/auth/dev?userId=${userId}`
  }

  public static logout() {
    return http.get('/auth/logout')
  }
}
